/**
 * @Description
 */

import { FC, useMemo, } from 'react';
import { isNotEmpty } from '@lhb/func';
import styles from './index.module.less';
import LabelRow from '../LabelRow';
import Scores from '../Scores';
import IconFont from '@/common/components/IconFont';

const Evaluation: FC<{
  detail,
  overView,
}> = ({
  detail,
  overView,
}) => {
  const cardView = useMemo(() => overView?.scores || [], [overView]);
  // 在这里编写组件的逻辑和渲染
  return (
    <div className={styles.evaluationCon}>
      <div className={styles.flexHeadCon}>
        <div style={{ flex: 1 }}>
          {detail?.areaName ? <div className={styles.titleRow}>
            <div className='c-222 fs-14 bold'>{detail?.areaName}</div>
            <IconFont iconHref='pc-common-icon-ic_arrow_right' className='fs-14 c-222'/>
          </div> : <>-</>}
          <LabelRow clusterId={detail?.id} detail={detail} overviewData={overView}/>
        </div>
        {
          overView?.showTotalScore ? <div className='ct mr-16 mb-6'>
            <div className='fs-20 c-569 ff-impact'>{isNotEmpty(overView?.marketScore) ? overView?.marketScore : '-'}</div>
            <div className='fs-12 c-222'>综合评分</div>
          </div> : <></>
        }
      </div>
      <Scores scores={cardView}/>
    </div>
  );
};

export default Evaluation;
